import { isDev } from '../server/helpers/env'

const daysToMilis = (days) => days * 24 * 60 * 60 * 1000

const daysToDate = (date, days) => {
  date.setTime(date.getTime() + daysToMilis(days))
  return date
}

const splitByTrim = (splitBy) => (x) => x.split(splitBy).map((y) => y.trim())

const formatExpireDate = (date) => `; expires=${date.toUTCString()}`

export const setCookie = (name, value, days) => {
  if (typeof document === 'undefined') return
  document.cookie = `${name}=${value || ''}${days ? formatExpireDate(daysToDate(new Date(), days)) : ''}; ${
    isDev ? '' : 'secure; '
  }samesite=lax; path=/`
}

export const deleteCookie = (name, value) => {
  if (typeof document === 'undefined') return

  document.cookie = `${name}=${value || ''};expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/`
}

export const getCookie = (name) => {
  if (typeof document === 'undefined') return

  return document.cookie
    .split(';')
    .map(splitByTrim('='))
    .reduce((acc, [key, val]) => (key === name ? val : acc), undefined)
}

export const getCookies = () => {
  return document.cookie
    .split(';')
    .map(splitByTrim('='))
    .reduce((acc, [key, val]) => {
      acc[key] = val
      return acc
    }, {})
}

const SEGMENT_SESSION_COOKIE = 'ajs_session_id'
const SEGMENT_SESSION_ID = 'id'
export const getSegmentSessionId = () => {
  if (typeof window !== 'undefined') {
    return new URLSearchParams(
      document.cookie.split(';').find((name) => name.trim().includes(SEGMENT_SESSION_COOKIE))
    ).get(SEGMENT_SESSION_ID)
  }
  return 'server-side-request'
}
